import { render, staticRenderFns } from "./manage-announcement.vue?vue&type=template&id=24d26cda"
import script from "./manage-announcement.vue?vue&type=script&lang=js"
export * from "./manage-announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports